module.exports = __webpack_public_path__ + "static/media/p1_s1.226368de.ogg";